import { Flex } from "antd";
import { ReactComponent as Camera } from "../../../../assets/images/icon/camera.svg";
import { ReactComponent as Img } from "../../../../assets/images/icon/img.svg";
import { useNavigate } from "react-router-dom";
import { useMyContext } from "../../../../entities/context";
import { useQuery } from "@tanstack/react-query";
import { getMemberByMemberId } from "../../../../service";
import { isLogin } from "../../../../utils";
import { CourseBadge } from "../../../../shared";

interface IProps {
  nickName: string;
}

const fetchMemberData = () => getMemberByMemberId().then((res) => res.data);

const CreateFeedForm = ({ nickName }: IProps) => {
  const navigate = useNavigate();
  const { feedPlaceholder } = useMyContext();
  const onClick = () => {
    navigate(`/create/feed`);
  };

  const { data: member } = useQuery({
    queryKey: ["member"],
    queryFn: fetchMemberData,
    enabled: isLogin(),
  });

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
          marginBottom: "8px",
        }}
      >
        <div className="sub-title/st2 base/black">{nickName}</div>
        {member?.isBadgeShow && (
          <CourseBadge
            style={{
              width: "auto",
              color: "var(--secondarys100)",
              backgroundColor: "var(--secondarys800)",
              padding: "2px 4px",
              borderRadius: "var(--radius2)",
            }}
            children="Coach"
          />
        )}
      </div>

      <div
        className="body/b3 secondary/s400"
        style={{ marginBottom: "8px" }}
        onClick={() => onClick()}
      >
        {feedPlaceholder}
      </div>
      <Flex
        style={{
          marginTop: 10,
          justifyContent: "right",
          gap: "var(--space8)",
        }}
      >
        <Img
          width={24}
          height={24}
          stroke="var(--secondarys500)"
          style={{ padding: "12px" }}
          onClick={(q) => navigate(`/create/feed?initForm=photo`)}
        />
        <Camera
          width={24}
          height={24}
          stroke="var(--secondarys500)"
          style={{ padding: "12px" }}
          onClick={(q) => navigate(`/create/feed?initForm=camera`)}
        />
      </Flex>
    </>
  );
};

export default CreateFeedForm;
